import type {InterfaceStrings} from './strings'

export const tr: InterfaceStrings = {
    nav: {
        beginSession: 'Başla',
        faq: 'SSS',
        pricing: 'Fiyatlar',
        legal: 'Yasal bilgiler',
        signIn: 'Giriş yap',
        viewPricing: 'Fiyatları gör',
        signOut: 'Çıkış yap',
        account: 'Hesap',
        menu: 'Menü',
        closeMenu: 'Menüyü kapat',
        mainNav: 'Ana gezinme',
        sessions: {one: '{n} seans', other: '{n} seans'},
    },
    footer: {
        selfHypnosisFor: 'Kendi kendine hipnoz',
        anxiety: 'Kaygı için',
        sleep: 'Uyku için',
        stress: 'Stres için',
        confidence: 'Özgüven için',
        focus: 'Odaklanma için',
        learn: 'Yöntem',
        ericksonian: 'Ericksoncu hipnoz nedir',
        aiHow: 'Yapay zekâ ile hipnoz nasıl çalışır',
        vsMeditation: 'Hipnoz mu, meditasyon mu',
        methods: 'Teknikler',
        languages: 'Diller',
    },
    page: {
        cta: 'Ücretsiz seansınıza başlayın',
        hint: 'İlk seansınız ücretsiz',
        exploreFurther: 'Daha fazlası',
        disclaimer:
            'Quies, rahatlama ve kendini keşif için bir iyi oluş aracıdır. Tıbbi bir cihaz değildir; hiçbir hastalığı teşhis etmez, tedavi etmez ya da iyileştirmez. Bir ruhsal kriz yaşıyorsanız lütfen bir uzmana başvurun.',
        transcript: 'Metin',
        transcriptNote: 'Gerçek bir Quies seansından, okunduğu hâliyle bir bölüm.',
        breadcrumb: 'Gezinme yolu',
    },
    pricing: {
        selectPlan: 'Bu paketi seç',
        subscribe: 'Abone ol',
        perMonth: 'aylık',
        manageSubscription: 'Aboneliği yönet',
        replayFree: 'Geçmiş bir seansı yeniden dinlemek her zaman ücretsizdir.',
        offerLead: 'Her seans, bir öncekinin bittiği yerden başlar.',
    },
    session: {
        chooseLanguage: 'Dilinizi seçin',
        changeLanguage: 'Dili değiştir',
        changeVoice: 'Sesi değiştir',
        previewVoice: '{voice} sesini dinle',
        stopPreview: 'Dinlemeyi durdur',
        continue: 'Devam',
        composing: 'Quies seansınızı yazıyor',
        preparing: 'Meditasyonunuz hazırlanıyor',
        pickingUp: 'kaldığınız yerden devam ediyoruz',
        today: 'Bugün',
        yesterday: 'Dün',
        loading: 'Yükleniyor…',
        showEarlier: 'Öncekileri göster ({count})',
        tryDifferentApproach: 'Başka bir yol dene',
        nothingAdded: 'Ekleme yok',
        purchaseConfirmed: 'Satın alma onaylandı',
        firstSessionNote: 'İlk seansınız ücretsiz. Dinlemeden önce giriş yapacaksınız.',
    },
    threshold: {
        title: 'Dinlemek için giriş yapın',
        message: 'İlk seansınız ücretsiz. Kart gerekmez.',
        google: 'Google ile devam et',
        sendLink: 'Bana giriş bağlantısı gönder',
        sending: 'Gönderiliyor…',
        emailLabel: 'E-posta adresi',
        or: 'veya',
        waitingTitle: 'E-postanızı kontrol edin',
        waitingBody: '{email} adresine bir giriş bağlantısı gönderdik.',
        sendAgain: 'Yeniden gönder',
        googleInstead: 'Bunun yerine Google ile giriş yap',
        codeLabel: 'Ya da e-postadaki 6 haneli kodu yazın',
        codeSubmit: 'Devam',
        codeSubmitting: 'Kontrol ediliyor…',
        codeWrong: 'Bu kod doğru değil.',
        codeDead: 'Bu kod artık geçerli değil. E-postadaki bağlantıyı kullanın ya da yeni bir tane gönderin.',
        errors: {
            invalidEmail: 'Geçerli bir e-posta adresi girin.',
            rateLimited: 'Çok fazla deneme yapıldı. Birkaç dakika sonra yeniden deneyin.',
            sessionError: 'Girişinizle ilgili bir sorun oluştu. Sayfayı yenileyip yeniden deneyin.',
            sendFailed: 'E-posta gönderilemedi. Lütfen yeniden deneyin.',
            sessionExpired: 'Girişinizin süresi doldu. Sayfayı yenileyip yeniden deneyin.',
            generic: 'Bir sorun oluştu. Lütfen yeniden deneyin.',
        },
    },
    player: {
        play: 'Oynat',
        pause: 'Duraklat',
        playAgain: 'Yeniden dinle',
        seek: 'Konum',
        eyesClosed: 'Gözler kapalı',
        openEyes: 'Gözleri aç',
        paused: 'Duraklatıldı',
        unavailable: 'Ses kullanılamıyor',
        untitled: 'Quies seansı',
    },
    failure: {
        turnFailed: 'Bizim tarafımızda bir sorun oluştu. Yanıtınız saklandı.',
        reconnecting: 'Yeniden bağlanıyor…',
        refusalTitle: 'Başka bir yoldan gidelim',
        refusal: 'Mesajınızın bir kısmına yanıt verilemedi. Farklı bir şekilde yazın ya da yeniden gönderin.',
        openElsewhere: 'Bu seans başka bir pencerede de açık.',
        serviceDown: 'Quies şu anda erişilemiyor. Yaptığınız hiçbir şey kaybolmadı.',
        sessionsUsedTitle: 'Seanslarınızı kullandınız',
        voiceFailedTitle: 'Meditasyonunuz yazıldı',
        voiceFailed: 'Şu anda seslendirilemedi. Hiçbir şey kaybolmadı ve yeniden seslendirmek ücretsiz.',
        voiceStopped: 'Ses yarıda kesildi. Kaldığı yerden devam edebilir.',
        streamMissing: 'Meditasyonunuz hazır, ancak bu sayfaya ulaşmadı.',
        tapToListen: 'Dinlemek için dokunun',
        fileFailed: 'Bu kayıt oynatılamıyor. Meditasyon ücretsiz olarak yeniden seslendirilebilir.',
        recordingGone: 'Bu kayıt artık saklanmıyor.',
        purchaseCancelled: 'Satın alma iptal edildi. Hiçbir ücret alınmadı.',
        purchasePending: 'Ödemeniz onaylandı. Seanslarınızın gelmesi her zamankinden uzun sürüyor.',
        checkoutFailed: 'Ödeme tamamlanamadı. Hiçbir ücret alınmadı.',
        sessionEnded: 'Bu seans sona erdi.',
        busy: 'Quies şu anda çok yoğun. Yanıtınız saklandı; bir dakika sonra yeniden deneyin.',
        tooLong: 'Bu seans Quies’in taşıyabileceğinden uzun hâle geldi. Size iade edildi.',
        notSaved: 'Bu adım kaydedilemedi. Kaldığınız yerden devam etmek için yeniden deneyin.',
        meditationRefused:
            'Bu meditasyon istendiği gibi yazılamadı. Farklı bir şekilde ifade edin ya da yeniden başlayın: bu seans size iade edilecek.',
        meditationRefusedUncharged:
            'Bu meditasyon istendiği gibi yazılamadı. Farklı bir şekilde ifade edin ya da yeniden başlayın.',
        linkExpired: 'Giriş bağlantınızın süresi doldu. Yenisini isteyin.',
        oauthFailed: 'Giriş yarıda kesildi. Lütfen yeniden deneyin.',
        offline: 'Çevrimdışısınız. Yanıtınız, bağlantınız geri gelir gelmez gönderilecek.',
        voiceChanged: 'Seçtiğiniz ses artık yok; bu meditasyonu başka bir ses okuyacak.',
        voiceReturned: 'Ses hâlâ oluşturulamadı. Bu seans size iade edildi.',
        voiceFailedAgain: 'Ses hâlâ oluşturulamadı.',
        voiceResuming: 'Ses yeniden başlıyor…',
        voiceLimited: 'Bu saat içinde sizin için zaten birkaç meditasyon seslendirildi. Biraz sonra yeniden deneyin.',
        tryAgain: 'Yeniden dene',
        rephrase: 'Yeniden ifade et',
        resume: 'Sürdür',
        voiceAgain: 'Yeniden seslendir',
        listen: 'Dinle',
        continue: 'Devam',
        begin: 'Seansa başla',
        signIn: 'Giriş yap',
        checkAgain: 'Yeniden kontrol et',
        sendLink: 'Giriş bağlantısı gönder',
        useEmail: 'E-posta ile devam et',
    },
}
